/** @jsx isolateComponent */
import { css } from '@emotion/react';

import { isolateComponent } from '@zapier/style-encapsulation';
import { IconButton } from '../../navigation/IconButton';

type Props = {
  /** Callback to navigate to next month */
  onNextClick: () => void;
  /** Callback to navigate to previous month */
  onPreviousClick: () => void;
};

const Styles = {
  root: css`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
  `,
};

export const DateRangePickerNavbar = ({
  onNextClick,
  onPreviousClick,
}: Props) => {
  return (
    <div css={Styles.root}>
      <IconButton
        icon="arrowSmallLeft"
        label="Previous Month"
        onClick={() => onPreviousClick()}
        shouldCorrectTooltipPosition={false}
        tooltipPosition="southwest"
        color="icon-secondary"
      />
      <IconButton
        icon="arrowSmallRight"
        label="Next Month"
        onClick={() => onNextClick()}
        shouldCorrectTooltipPosition={false}
        tooltipPosition="southeast"
        color="icon-secondary"
      />
    </div>
  );
};
